import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'shared-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  @Input() title: string = '';
  @Input() items: any[] = [];
  @Input() active_item: string = '';
  @Input() activeBackButton: boolean = false;
  @Input() backLink: string = '';

  constructor(
    private _location: Location,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  public onBack(): void {
    this._location.back();
  }

  public get fullBreadcrumbPath(): string {
    const list = [...(this.items || []), this.active_item].filter(Boolean);
    return list.map((item) => this.translate.instant(item)).join(' / ');
  }
}
